import { memo } from "react";
import { areEqual, ListChildComponentProps } from "react-window";
import { DocumentNode } from "@apollo/client";

import { ListEntitiesBaseItemProps } from "components/ListEntitiesNew";

import { ApiKeyLegacyListView } from "../types";
import ApiKeysListItem from "./Item";

type ApiKeysListVirtualizedItemProps = {
  apiKeys: ApiKeyLegacyListView[];
  handleApiKeyOpenDetails: (details: ApiKeyLegacyListView) => unknown;
  refetchQueriesOnDelete?: DocumentNode[];
};

const ApiKeysListVirtualizedItem = (
  props: ListChildComponentProps<ApiKeysListVirtualizedItemProps & ListEntitiesBaseItemProps>
) => {
  const { index, style, data } = props;

  const item = data.apiKeys[index];

  const handleSetRowHeight = (size: number) => data.setRowHeight(index, size);

  return (
    <div style={style}>
      <ApiKeysListItem
        key={item.id}
        item={item}
        handleApiKeyOpenDetails={data.handleApiKeyOpenDetails}
        setRowHeight={handleSetRowHeight}
        refetchQueriesOnDelete={data.refetchQueriesOnDelete}
      />
    </div>
  );
};

export default memo(ApiKeysListVirtualizedItem, areEqual);
